<template>
    <div :id="p_mapUid_s" class="TQ_bg_white">
    </div>
</template>

<script>
import GestureHandling from "leaflet-gesture-handling";
import {FB_MapData} from "../../../functions/src/shareCode/Share_S_Classes";
import Leaflet from 'leaflet'
import "leaflet/dist/leaflet.css";
import {svg_getMarkerHtml_s} from "@/scripts/S_Svg";
import {ass_img_square_w} from "@/assets/scripts/Ass_Files";

export default {
    name: "TqMapEdit",
    props:{
        p_mapUid_s : {
            type: String,
            default: "mapId"
        },
        p_mapData_c : {
            type: FB_MapData,
            require: true
        },
        p_markers_ac:{
            type: Array,
            default: []
        }
    },
    data(){
        return {
            myMap_l : null,
            riddles_markers_al : {},
            editMarkers_al : [],
            clickDragMarker_b : false
        }
    },
    methods:{
        m_drawOnMap_marker_f(mapPoint_c, key, markerColor_s= '#501078'){

            let riddleMarker_l = L.marker(
                [mapPoint_c.mp_lat_n, mapPoint_c.mp_lng_n],
                {
                    icon: L.divIcon({
                        className   : "",
                        html        : svg_getMarkerHtml_s(markerColor_s),
                        iconSize    : [38, 95], // size of the icon
                        iconAnchor  : [19, 40], // point of the icon which will correspond to marker's location
                    }),
                })

            riddleMarker_l.addTo(this.myMap_l)
            riddleMarker_l.index = this.riddles_markers_al.length

            this.riddles_markers_al[key] = riddleMarker_l

            // this.m_addDraggableMarker_fl(mapPoint_c, newLatLng_o => riddleMarker_l.setLatLng(newLatLng_o))
        },

        m_addDraggableMarker_fl(mapPoint_c, cb_f, mouseUpCb_f){

            const dragMarker = L.marker(
                [mapPoint_c.mp_lat_n, mapPoint_c.mp_lng_n],
                {
                    icon: L.icon({
                        iconUrl: ass_img_square_w,
                        iconSize:     [16, 16], // size of the icon
                        iconAnchor:   [8, 8], // point of the icon which will correspond to marker's location
                    }),
                    draggable:'true'
                })
                .addTo(this.myMap_l)
                .on('drag', (event) => {
                    let marker = event.target;
                    let position_o = marker.getLatLng();

                    delete position_o.mp_lng_n
                    delete position_o.mp_lat_n

                    cb_f(position_o)
                })
                .on('dragstart', (event) => {
                    this.clickDragMarker_b = true
                })
                .on('dragend', (event) => {
                    this.clickDragMarker_b = false
                    let marker = event.target;
                    let position_o = marker.getLatLng();

                    delete position_o.mp_lng_n
                    delete position_o.mp_lat_n

                    if(mouseUpCb_f){mouseUpCb_f(position_o)}
                })

            this.editMarkers_al.push(dragMarker);

            return dragMarker
        },

        m_mounted_initMap_f(){

            this.myMap_l = Leaflet.map(this.p_mapUid_s, {
                attributionControl  : false,
                gestureHandling     : true,
            })

            Leaflet.Map.addInitHook("addHandler", "gestureHandling", GestureHandling);

            this.myMap_l.setView([this.p_mapData_c.md_center_c.mp_lat_n, this.p_mapData_c.md_center_c.mp_lng_n], this.p_mapData_c.md_zoom_n);

            Leaflet.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                maxZoom: 20,
                minZoom: 4,
            }).addTo(this.myMap_l);

            this.myMap_l.keyboard.disable();

            this.p_markers_ac.forEach((mapPoint_c, key) => {
                this.m_drawOnMap_marker_f(mapPoint_c, key)
            })
        },


    },

    mounted(){
        this.m_mounted_initMap_f()
    },

    watch:{
        p_markers_ac:{
            handler(){
                this.p_markers_ac.forEach((mapPoint_c, key) => {
                    this.riddles_markers_al[key].setLatLng([mapPoint_c.mp_lat_n, mapPoint_c.mp_lng_n])
                })
            },
            deep: true
        }
    }
}
</script>

<style scoped>

</style>